import { Consulta } from "./Consulta";
import ConsultaService from "./services/ConsultaService";


let document = window.document; //Esto solo es necesario hacerlo con motivo de test. Si no, el "document" puede ser accedido sin necesidad de declararlo.
export class Form {
    constructor(id, temasConsultaRepository, idConsultaReabrir, documentTest) {


      //el "document" es una dependencia del Form, lo que pasa es que cuando se ejecuta en un nevagador, ya es directamente accesible, porque está
      //declarado globalmente. Pero si instanciamos el FORM desde un testcase, hay que inyectar esa dependencia y la pasamos en el contructor.
      //Esto es una mala práctica, ya que estamos modificando el código de producción para poder testearlo, pero ahora mismo no se me ocurre otra manera.
      if(documentTest == null){ 
        document = window.document;
      }
      else{
        document = documentTest;
      }

      this.htmlForm = document.getElementById(id);
      this.formBody = this.htmlForm.querySelector(".js-form-body");
      this.errorMessage = this.htmlForm.querySelector(".js-form-error");
      this.errorMessageTiempoSuperado = this.htmlForm.querySelector(".js-form-error-tiempo-superado");
      this.thanksMessage = this.htmlForm.querySelector(".js-form-thanks");

      this.loadTemaConsultas(temasConsultaRepository.searchAll());

      this.htmlForm.addEventListener("submit", (ev) => this.submit(ev));

      const botonNueva = document.getElementById("botonNueva");
      botonNueva.addEventListener("click", () => this.nuevaConsulta());

      const botonReabrir = document.getElementById("botonReabrir");
      botonReabrir.addEventListener("click", () => this.reabrirConsulta());

      if(idConsultaReabrir != null){
  
        this.reabrirConsulta(idConsultaReabrir);

      }else{

        this.nuevaConsulta();
        
      }

    }

    nuevaConsulta(){
      const formErroresValidacion = Object.values(this.htmlForm.getElementsByClassName("js-form-validation-error"));

      formErroresValidacion.forEach((control) => {
        control.classList.add("hidden");
      });
      
      this.formularioActivo = "NuevaConsulta";
      botonNueva.classList.remove("btn-secondary");
      botonNueva.classList.add("btn-primary");
      botonReabrir.classList.remove("btn-primary");
      botonReabrir.classList.add("btn-secondary");
      const elemetosFormReabrir = Object.values(this.htmlForm.getElementsByClassName("reabrir-form"));
      const elemetosFormConsulta = Object.values(this.htmlForm.getElementsByClassName("consulta-form"));

      elemetosFormReabrir.forEach((control) => {
        control.classList.add("hidden");
      });

      elemetosFormConsulta.forEach((control) => {
        control.classList.remove("hidden");
      });
    
    }

    reabrirConsulta(idConsultaReabrir){
      const formErroresValidacion = Object.values(this.htmlForm.getElementsByClassName("js-form-validation-error"));

      formErroresValidacion.forEach((control) => {
        control.classList.add("hidden");
      });
      
      this.formularioActivo = "ReabrirConsulta";
      botonNueva.classList.remove("btn-primary");
      botonNueva.classList.add("btn-secondary");
      botonReabrir.classList.remove("btn-secondary");
      botonReabrir.classList.add("btn-primary");
      
      const elemetosFormConsulta = Object.values(this.htmlForm.getElementsByClassName("consulta-form"));
      const elemetosFormReabrir = Object.values(this.htmlForm.getElementsByClassName("reabrir-form"));

      elemetosFormConsulta.forEach((control) => {
        control.classList.add("hidden");
      });
      elemetosFormReabrir.forEach((control) => {
        control.classList.remove("hidden");
      });

      if (idConsultaReabrir != null){
          document.getElementById("idConsulta").value=idConsultaReabrir;
          document.getElementById("idConsulta").disabled = true;
      }

    }


    submit(ev) {
        ev.preventDefault();
       
        if(this.formularioActivo == "NuevaConsulta" && this.isFormularioConsultaValid()){
          this.handleFormSuccess();           
        }
        else if(this.formularioActivo=="ReabrirConsulta" && this.isFormularioReabrirValid()){
          this.handleFormSuccess();
        }
    }

    handleFormSuccess() {
      this.htmlForm.elements.botonEnviar.disabled = true;
      const consulta = this.createConsulta();
      const file = document.getElementById("uploadFile").files[0];

      if(file){
        if(this.formularioActivo == "NuevaConsulta"){
          this.enviaConsultaConAdjunto(consulta, file);
        }else{
          this.reabreConsultaConAdjunto(consulta, file);
        }
      }
      else{ 
        if(this.formularioActivo == "NuevaConsulta"){
          this.enviaConsulta(consulta, file);
        }else{
          this.reabreConsulta(consulta, file);
        }
      } 
    }
    
    createConsulta() {
      const data = Object.values(this.htmlForm.elements).reduce(
        (consulta, element) => {

          if (element.id) {
            consulta[element.id] = element.value;
          }
          return consulta;
        },
        {}
      );

        //TODO: Esta manera de sacar el valor de los radio button no es la mejor. Ver como hacerlo en el "reduce".
        if(document.getElementById("sexo_hombre").checked){
          data["sexo"] = "Hombre";
        }
        else{
          data["sexo"] = "Mujer";
        }

      const consulta = new Consulta(data);
  
      return consulta;
      
    }  

    enviaConsulta(consulta){
      
      this.formBody.classList.add("hidden");
      
      document.getElementById("header").scrollIntoView();

      document.getElementById("spinner1").classList.remove("hidden");

    
      let self = this;
     
      grecaptcha.ready(function() {
        grecaptcha.execute(RECAPTCHA_API_KEY, {action: 'submit'}).then(function(token) {
            
          let consultaService = new ConsultaService();

            consultaService.enviaConsulta(consulta, token).then(respuesta => {     
            if(respuesta.ok){
              self.thanksMessage.classList.remove("hidden"); 
            }
            else{
              self.errorMessage.classList.remove("hidden"); 
            } 
          })
          .catch(respuesta => {
            self.errorMessage.classList.remove("hidden"); 
          })
          .finally(respuesta => {
    
            document.getElementById("spinner1").classList.add("hidden"); 
            self.htmlForm.reset();
          });

        });
      });
       
    }

    enviaConsultaConAdjunto(consulta, file){
      
      this.formBody.classList.add("hidden");
      
      document.getElementById("header").scrollIntoView();

      document.getElementById("spinner1").classList.remove("hidden");

    
      let self = this;
    
      grecaptcha.ready(function() {
        grecaptcha.execute(RECAPTCHA_API_KEY, {action: 'submit'}).then(function(token) {
            
          let consultaService = new ConsultaService();

          consultaService.enviaConsultaConFicheroAdjunto(consulta,file, token).then(respuesta => {     
            if(respuesta.ok){
              self.thanksMessage.classList.remove("hidden"); 
            }
            else{
              self.errorMessage.classList.remove("hidden"); 
            } 
          })
          .catch(respuesta => {
            self.errorMessage.classList.remove("hidden"); 
          })
          .finally(respuesta => {
    
            document.getElementById("spinner1").classList.add("hidden"); 
            self.htmlForm.reset();
          });

        });
      });
       

    }


    reabreConsulta(consulta){
      
      this.formBody.classList.add("hidden");
      
      document.getElementById("header").scrollIntoView();

      document.getElementById("spinner1").classList.remove("hidden");

    
      let self = this;
     
      grecaptcha.ready(function() {
        grecaptcha.execute(RECAPTCHA_API_KEY, {action: 'submit'}).then(function(token) {
            
            let consultaService = new ConsultaService();

            consultaService.reabreConsulta(consulta, token)
            .then(respuesta => {

            if(respuesta.ok){
              self.thanksMessage.classList.remove("hidden"); 
            }
            else{
                 respuesta.json().then(respuestaJson =>
                        {
                            if(respuestaJson.error_code == "consulta_excede_limite_temporal"){
                               self.errorMessageTiempoSuperado.classList.remove("hidden");

                            }
                            else{
                               self.errorMessage.classList.remove("hidden");
                               console.log("error_code: " +respuestaJson.error_code);
                               console.log("message: " +respuestaJson.message);
                            }
                        }
                 )

            }
          })
          .catch(respuesta => {
            self.errorMessage.classList.remove("hidden");
          })
          .finally(respuesta => {
    
            document.getElementById("spinner1").classList.add("hidden"); 
            self.htmlForm.reset();
          });

        });
      });
       
    }


    reabreConsultaConAdjunto(consulta, file){
      
      this.formBody.classList.add("hidden");
      
      document.getElementById("header").scrollIntoView();

      document.getElementById("spinner1").classList.remove("hidden");

    
      let self = this;
     
      grecaptcha.ready(function() {
        grecaptcha.execute(RECAPTCHA_API_KEY, {action: 'submit'}).then(function(token) {
            
          let consultaService = new ConsultaService();

            consultaService.reabreConsultaConFicheroAdjunto(consulta, file, token)
            .then(respuesta => {

             if(respuesta.ok){
               self.thanksMessage.classList.remove("hidden");
             }
             else{
                  respuesta.json().then(respuestaJson =>
                         {
                             if(respuestaJson.error_code == "consulta_excede_limite_temporal"){
                                self.errorMessageTiempoSuperado.classList.remove("hidden");

                             }
                             else{
                                self.errorMessage.classList.remove("hidden");
                                console.log("error_code: " +respuestaJson.error_code);
                                console.log("message: " +respuestaJson.message);
                             }
                         }
                  )

             }
           })
         .catch(respuesta => {
           self.errorMessage.classList.remove("hidden");
         })
          .finally(respuesta => {
    
            document.getElementById("spinner1").classList.add("hidden"); 
            self.htmlForm.reset();
          });

        });
      });
       
    }
    
    isFormularioReabrirValid() {
      const formErroresValidacion = Object.values(this.htmlForm.getElementsByClassName("js-form-validation-error"));

      formErroresValidacion.forEach((control) => {
        control.classList.add("hidden");
      });
      
      const validateIdConsulta = this.validateIdConsulta(this.htmlForm.elements.idConsulta);

      const validateTipoDeDocumento = this.validateTipoDeDocumento(this.htmlForm.elements.tipoDeDocumento);

      var validateDocumentoIdentificacion;
      
      if(validateTipoDeDocumento){
        validateDocumentoIdentificacion = this.validateDocumentoIdentificacion(this.htmlForm.elements.documentoIdentificacion, this.htmlForm.elements.tipoDeDocumento.value);
      }

      const validateTextoConsulta = this.validateRequiredField(this.htmlForm.elements.textoConsulta);

      var validateAdjunto = true;
      var validateDescripcionAdjunto = true;

      if(document.getElementById("uploadFile").value != 0){
        validateAdjunto = this.validateAdjunto(document.getElementById("uploadFile"));
        validateDescripcionAdjunto = this.validateRequiredField(this.htmlForm.elements.descripcionAdjunto);
      }

      const validateAvisoLegal = this.validateAvisoLegal(this.htmlForm.elements.avisoLegal);

      const isValid =
      validateIdConsulta &&
      validateTipoDeDocumento &&
      validateDocumentoIdentificacion &&
      validateTextoConsulta &&
      validateAdjunto &&
      validateDescripcionAdjunto &&
      validateAvisoLegal;
      
     if(!isValid){
       this.ponFocoEnPrimerError();
     }

     return isValid;

    }

    validateIdConsulta(field){
   
      const er = /^\d{6,7}/u;
 
       const isValid = er.test(field.value);
       
   
       if (!isValid) {
         
         this.activaErrorEnElemento(field, "Error en el formato del identificador.")
         
       }
       return isValid;
     }

    isFormularioConsultaValid() {
      //Añadir los elementos al HTML, y al principio añadir todos los hidden necesarios y jugar con eso. 
    
      const formErroresValidacion = Object.values(this.htmlForm.getElementsByClassName("js-form-validation-error"));

      formErroresValidacion.forEach((control) => {
        control.classList.add("hidden");
      });
  
      const validaNombreRequerido = this.validateRequiredField(this.htmlForm.elements.nombre);

      var validateFormatoNombre;
      if(validaNombreRequerido){
        validateFormatoNombre = this.validateFormatoNombreApellidos(this.htmlForm.elements.nombre);
      }

      const validaApellidosRequerido = this.validateRequiredField(this.htmlForm.elements.apellidos);

      var validateFormatoApellidos;
      if(validaApellidosRequerido){
        validateFormatoApellidos = this.validateFormatoNombreApellidos(this.htmlForm.elements.apellidos);
      }

      const validateTipoDeDocumento = this.validateTipoDeDocumento(this.htmlForm.elements.tipoDeDocumento);

      var validateDocumentoIdentificacion;
      
      if(validateTipoDeDocumento){
        validateDocumentoIdentificacion = this.validateDocumentoIdentificacion(this.htmlForm.elements.documentoIdentificacion, this.htmlForm.elements.tipoDeDocumento.value);
      }

      const validateCorreoElectronico = this.validateCorreoElectronico(this.htmlForm.elements.correoElectronico);

      const validateTelefonoMovil = this.validateTelefonoMovil(this.htmlForm.elements.telefonoMovil);

      const validateCodigoPostal = this.validateCodigoPostal(this.htmlForm.elements.codigoPostal);

      const validateTemaConsulta = this.validateTemaConsulta(this.htmlForm.elements.temaConsulta);

      const validateTextoConsulta = this.validateRequiredField(this.htmlForm.elements.textoConsulta);

      
      var validateAdjunto = true;
      var validateDescripcionAdjunto = true;

      if(document.getElementById("uploadFile").value != 0){
        validateAdjunto = this.validateAdjunto(document.getElementById("uploadFile"));
        validateDescripcionAdjunto = this.validateRequiredField(this.htmlForm.elements.descripcionAdjunto);
      }

      const validateAvisoLegal = this.validateAvisoLegal(this.htmlForm.elements.avisoLegal);


      const isValid =
       validaNombreRequerido && 
       validateFormatoNombre &&
       validaApellidosRequerido &&
       validateFormatoApellidos &&
       validateCorreoElectronico &&
       validateTipoDeDocumento &&
       validateDocumentoIdentificacion &&
       validateTelefonoMovil && 
       validateCodigoPostal &&
       validateTemaConsulta &&
       validateTextoConsulta &&
       validateAdjunto &&
       validateDescripcionAdjunto &&
       validateAvisoLegal;
       
      if(!isValid){
        this.ponFocoEnPrimerError();
      }

      return isValid;
    }

    ponFocoEnPrimerError(){
      const inputs = this.htmlForm.elements;
      
      // Iterate over the form controls
      for (let i = 0; i < inputs.length; i++) {

        if(inputs[i].classList.contains("form-control")){
          if(!inputs[i].nextElementSibling.classList.contains("hidden")){
            
            inputs[i].focus();
            return;
          }
        
        }
      }
    }

    validateAdjunto(field){
      var isValid = false;
    
      var tipo = field.files[0].type;
      var tamanio = field.files[0].size;
      if(tipo == "image/png" || tipo == "image/jpeg"){
        if(tamanio < 10000000){
          isValid = true;
        }
      }
      if (!isValid) {
        this.activaErrorEnElemento(field, "El archivo no es válido. Solo puede ser de tipo png y jpg, con un tamaño máximo de 10MB.")
      }
  
      return isValid;
    }

    validateRequiredField(field) {
      const isValid = !!field.value;
  
      if (!isValid) {

        this.activaErrorEnElemento(field, "Este campo es obligatorio.")
      
      }
      return isValid;
    }

    validateFormatoNombreApellidos(field){
   
     const er = /^\S[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u;
   

      const isValid = er.test(field.value);
      
  
      if (!isValid) {
        
        this.activaErrorEnElemento(field, "Error en el formato.")
        
      }
      return isValid;
    }

    validateAvisoLegal(field){
      const isValid = field.checked;
  
      if (!isValid) {

        const elementoError = field.nextElementSibling.nextElementSibling;

        elementoError.classList.remove("hidden");
  
        elementoError.innerHTML = "Debe aceptar los términos del aviso legal.";

             
      }
      return isValid;
    }
    
    validateTemaConsulta(field){
      const isValid = field.selectedIndex != 0;
  
      if (!isValid) {

        this.activaErrorEnElemento(field, "Este campo es obligatorio.")
      
      }
      return isValid;
    }


    validateCorreoElectronico(field) {
      
      const er = /^[a-zA-Z0-9\._-]+@[a-zA-Z0-9-]{2,}[.][a-zA-Z]{2,4}$/;

      const isValid = er.test(field.value);
      
  
      if (!isValid) {
        
        this.activaErrorEnElemento(field, "Error en el correo electrónico.")
        
      }
      return isValid;
    }

    validateTelefonoMovil(field) {
      
      //TODO: No se porqué pero no pilla la ER si la pongo como las otras. Habrá que escapar algún caracter.
      const er = /^[8|7|6]{1}([\d]{2}[-]*){3}[\d]{2}$/;
            
      const isValid = er.test(field.value);
  
      if (!isValid) {
        
        this.activaErrorEnElemento(field, "Error en el teléfono móvil.")
        
      }
      return isValid;
    }

    validateTipoDeDocumento(field){
         
      const isValid = new RegExp(
        "^(NIF|NIE|Pasaporte)$"
      ).test(field.selectedOptions[0].label); 

      if (!isValid) {
        
        this.activaErrorEnElemento(field, "Elige un tipo de documento.")
        
      }
      return isValid;
    }

    validateDocumentoIdentificacion(field, tipoDeDocumento){

      const isValid = this.validarNifNieCifPasaporte(field.value,tipoDeDocumento);

      if(!isValid){
        this.activaErrorEnElemento(field, "Error en el número de identificación")
      }

      return isValid;
    }

    activaErrorEnElemento(elemento, mensajeError) {
     

      const elementoError = elemento.nextElementSibling;

      elementoError.classList.remove("hidden");

      elementoError.innerHTML = mensajeError;

    }



    /**
 * Función para verificar un NIF, NIE, o CIF
 */
    validarNifNieCifPasaporte(documentoIdentificacion, tipoDeDocumento) {

      var isValid = true;

      let documentoIdentificacionUpper = documentoIdentificacion.toUpperCase();

      // NIF de tipo DNI o CIF
      if(tipoDeDocumento == "NIF") {

        if(this.isValidDNI(documentoIdentificacionUpper) || this.isValidCIF(documentoIdentificacionUpper))
        {
            isValid = true;
        }
        else{
            isValid = false;
        }
      }




        // NIE
      // Nota: No se validan los que empiezan por K,L,M
      if(tipoDeDocumento == "NIE") {
        
        //let documentoIdentificacionUpper = documentoIdentificacion.toUpperCase();
        const letras = "TRWAGMYFPDXBNJZSQVHLCKE";
        
        if (!(new RegExp('^[XYZ][0-9]{7}[A-Z]$').test(documentoIdentificacionUpper))) {
          isValid = false;
        } else {
          // Si cumple con el formato comprobamos letra
          
          // Reemplazamos X=0, Y=1, Z=2
          if (documentoIdentificacionUpper.charAt(0) == "X") {
            documentoIdentificacionUpper = "0" + documentoIdentificacionUpper.substr(1, 9);
          } else if (documentoIdentificacionUpper.charAt(0) == "Y") {
            documentoIdentificacionUpper = "1" + documentoIdentificacionUpper.substr(1, 9);
          } else if (documentoIdentificacionUpper.charAt(0) == "Z") {
            documentoIdentificacionUpper = "2" + documentoIdentificacionUpper.substr(1, 9);
          }
          
          // Comprobamos como si fuera NIF
          if (letras[(documentoIdentificacionUpper.substr(0, 8) % 23)] != documentoIdentificacionUpper.charAt(8)) {
            isValid = false;
          }			
        }	
      }

      
      // Pasaporte
      if(tipoDeDocumento == "Pasaporte") {
       // const documentoIdentificacionUpper = documentoIdentificacion.toUpperCase();
        
        if(!(new RegExp('^[A-Z0-9]{6,9}$').test(documentoIdentificacionUpper))){
             
            isValid = false;
        }
      }

      return isValid;
    }

  isValidDNI(identificador){
        const letras = "TRWAGMYFPDXBNJZSQVHLCKE";
        var isValid = true;

        if (!(new RegExp('^[0-9]{8}[A-Z]$').test(identificador))
        || letras[(identificador.substr(0, 8) % 23)] !== identificador.charAt(8)) {
          isValid = false;
        }
      
        return isValid;
  }

  isValidCIF(identificador){
      var isValid = false;

      if(/([A-W]{1})(\d{7})([A-Z0-9]{1})$/gm.test(identificador)){
          isValid = true;
      }
      
      return isValid;
  }


  validateCodigoPostal(field) {
      
    const er = /^(0|1|2|3|4|5){1}(\d){4}$/;
          
    const isValid = er.test(field.value);

    if (!isValid) {
      
      this.activaErrorEnElemento(field, "Error en el código postal.")
      
    }
    return isValid;
  }




    loadTemaConsultas(temasConsulta){
 
        const select = document.getElementById("temaConsulta");

        temasConsulta
        .then(({ data }) => {
          for (const item of data) {
            const option = document.createElement("option");
            option.textContent = item.name;
            option.value = item.value;
            select.append(option);
          }
            
          select.selectedIndex = 0;
          //TODO: Este método para cargar debería ser genérico, con lo que esto no tendría que estar aquí.       
        })
        .catch(() => {
          //console.error(`Could not find ${type}.json`);
          //TODO: Ver qué hacer con este error.
        });

      
    }


}